var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right mr-5"},[_c('b-button',{attrs:{"to":{ name: 'usuario-editar-mi-perfil'},"variant":"primary"}},[_vm._v(" Editar Mi Perfil ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }